export default __webpack_public_path__ + "static/media/boussole.123ae6ac.svg";